import GuestType, { GuestTypesEnum } from "./GuestType";

export default class CommuneGuestTypeOption {
    public guestType: GuestType;
    public label: string;
    public isAnnual: boolean;
    public subGuestType: string;
  
    public constructor(
        guestType?: GuestType,
        label?: string,
        isAnnual?: boolean,
        subGuestType?: string
      ){
        this.guestType = guestType || GuestTypesEnum.overnight;
        this.label = label || '';
        this.isAnnual = isAnnual || false;
        this.subGuestType = subGuestType || ''
      } 
  };